// 勤務希望地
const data = [
    {
        key: '東京都',
        value: 'KAN10',
    },
    {
        key: '神奈川県',
        value: 'KAN20',
    },
    {
        key: '埼玉県',
        value: 'KAN30',
    },
    {
        key: '千葉県',
        value: 'KAN40',
    },
    {
        key: '福岡県',
        value: 'KYU10',
    },
];

export default data;